import React, { useEffect, useState } from "react";
import aries from "../../../assets/images/Horoscope/astro.png";
import Aquarius from "../../../assets/images/Horoscope/c.jpg";
import cancer from "../../../assets/images/Horoscope/cancer.jpg";
import capricorn from "../../../assets/images/Horoscope/capricornus.jpg";
import Leo from "../../../assets/images/Horoscope/leo.jpg";
import libra from "../../../assets/images/Horoscope/libra.jpg";
import pisces from "../../../assets/images/Horoscope/pisces.jpg";
import sagittarius from "../../../assets/images/Horoscope/sssagittarius.jpg";
import taurus from "../../../assets/images/Horoscope/taurussss.jpg";
import virgo from "../../../assets/images/Horoscope/virgo.jpg";
import Zodiac from "../../../assets/images/Horoscope/ic_gemini.png";
import Scorpio from "../../../assets/images/Horoscope/scorpio.jpg";
import { GetUserModel } from "../../../ApiServices/Profile/ProfileApi";
import { daily_nakshatra_prediction } from "../../../ApiServices/Horoscope/BirthDetailsApi";
import dayjs from "dayjs";
import PredictionModal from "./PredictionModal";
import Breadcrumbs from "../../Breadcrumb";
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import astroBackgroundImg from '../../../assets/images/Horoscope/horoscopeBackgroundImg.png'
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import NumerologyImage from "../../../assets/images/new/services1 (3).jpg";
import PredictionImage from "../../../assets/images/new/services1 (3).jpg";
import { useLocation, useNavigate } from "react-router-dom";
const Prediction = () => {
  const [dailyPredictionList, setDailyPredictionObj] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [predictionTitle, setPredictionTitle] = useState(null);
  const navigate = useNavigate()
  const location = useLocation()
  const zodiacData = [
    { zodiacSign: 'Aries', zodiacName: 'Mesha', zodiacLogo: aries },
    { zodiacSign: 'Taurus', zodiacName: 'Vrishabha', zodiacLogo: taurus },
    { zodiacSign: 'Gemini', zodiacName: 'Mithuna', zodiacLogo: Zodiac },
    { zodiacSign: 'Cancer', zodiacName: 'Karka', zodiacLogo: cancer },
    { zodiacSign: 'Leo', zodiacName: 'Simha', zodiacLogo: Leo },
    { zodiacSign: 'Virgo', zodiacName: 'Kanya', zodiacLogo: virgo },
    { zodiacSign: 'Libra', zodiacName: 'Tula', zodiacLogo: libra },
    { zodiacSign: 'Scorpio', zodiacName: 'Vrishchika', zodiacLogo: Scorpio },
    { zodiacSign: 'Sagittarius', zodiacName: 'Dhanu', zodiacLogo: sagittarius },
    { zodiacSign: 'Capricorn', zodiacName: 'Makara', zodiacLogo: capricorn },
    { zodiacSign: 'Aquarius', zodiacName: 'Kumbha', zodiacLogo: Aquarius },
    { zodiacSign: 'Pisces', zodiacName: 'Meena', zodiacLogo: pisces },
  ];
  const categories = [
    {
      title: "Astrology",
      image: Astro,
      icon: astrology,
      text: "Book Astrology for your spiritual rituals and ceremonies.",
      color: "#ffa415",
      route: "/basic-details",
    },
    {
      title: "Panchang",
      image: Panchang,
      icon: panchang,
      text: "Get a Panchang for your up and down ",
      color: "#fc5528",
      route: "/daily-panchang",
    },
    {
      title: "Numerology",
      image: NumerologyImage,
      icon: numerology,
      text: "Numerology for better life",
      color: "#8139e7",
      route: "/numerology",
    },
    {
      title: "Zodiac Signs",
      image: PredictionImage,
      icon: zodiacSign,
      text: "Know about Prediction",
      color: "#399be7",
      route: "/Prediction",
    }

  ];
  useEffect(() => {
    GetUserModelData();
  }, []);

  const GetUserModelData = async () => {
    // setLoader(true);

    const userID = JSON.parse(localStorage.getItem("userID"));
    try {
      const response = await GetUserModel(userID);
      if (response?.ResponseCode == 0) {
        // setLoader(false);
        const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item

        const dob = new Date(ModelData[0]?.DOB);

        const year = dob.getFullYear();
        const month = dob.getMonth() + 1; // Months are zero-based (0 = January)
        const day = dob.getDate();

        const [hours, minutes] = ModelData[0]?.BIRTH_TIME.split(":");
        const apiParam = {
          day: day.toString(),
          month: month.toString(),
          year: year.toString(),
          hour: hours.toString(),
          min: minutes.toString(),
          lat: 25.7464,
          lon: 25.7464,
          tzone: 5.5,
        };
        await GetDailyPredictionData(
          apiParam,
          dayjs(ModelData[0]?.DOB).format("DD/MM/YYYY")
        );
      } else {
        // setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      // setLoader(false);

      console.error("Error", error);
    }
  };
  const GetDailyPredictionData = async (apiParam, birthDate) => {
    console.log("apiParam", apiParam);
    try {
      const response = await daily_nakshatra_prediction(apiParam);
      if (response !== null && response !== undefined) {
        // setLoader(false);
        setDailyPredictionObj((prev) => ({
          ...prev,
          Health: response?.prediction?.health,
          Emotion: response?.prediction?.emotions,
          Profession: response?.prediction?.profession,
          Luck: response?.prediction?.luck,
          Personal_life: response?.prediction?.personal_life,
          Travel: response?.prediction?.travel,
        }));
      } else {
        // setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      // setLoader(false);

      console.error("Error", error);
    }
  };

  const handleClickedOnSign = (value) => {
    setShowModal(true);
    setPredictionTitle(value);
  };
  return (
    <>
      <section className="page-header" style={{ paddingBottom: '30px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">Zodiac Prediction</h2>
          <div >
            <Breadcrumbs />
          </div>
        </div>
      </section>

      <div className="container pt-4">
        {/* Mobile horizontal scroll */}
        <div className="d-flex d-md-none overflow-auto px-2">
          {categories.map((category, index) => (
            <div
              key={index}
              className="text-center me-3 flex-shrink-0"
              style={{ width: "100px", cursor: "pointer" }}
              onClick={() => navigate(`${category?.route}`)}
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.route === location?.pathname
                      ? "#a52444"
                      : "#212529",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>

        {/* Desktop grid layout */}
        <div className="row justify-content-center text-center g-4 d-none d-md-flex w-100">
          {categories.map((category, index) => (
            <div
              key={index}
              className="col-6 col-sm-4 col-md-2"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`${category?.route}`)}
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.route === location?.pathname
                      ? "#a52444"
                      : "#212529",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div class="row p-2 mx-1" style={{ width: '99%' }}  >

        {zodiacData.map((zodiac, index) => (
          <div key={index} className="col-md-3 col-sm-6 mb-4 p-2">
            <div
              className="card shadow-md border-0 p-4 text-center"
              style={{ cursor: 'pointer' }}
              onClick={() => handleClickedOnSign(zodiac.zodiacSign)}
            >
              <div className="zodiac-icon">
                <img
                  width={50}
                  height={50}
                  src={zodiac.zodiacLogo}
                  alt={zodiac.zodiacName}
                  className="rounded-circle border"
                />
              </div>
              <h5 className="fw-bold mb-2 zodiac-name " style={{ textAlign: "center" }}>{zodiac.zodiacSign}</h5>
              <p className="zodiac-sign" style={{ textAlign: "center" }}>
                {zodiac.zodiacName}
              </p>
            </div>
          </div>
        ))}


      </div>

      <PredictionModal
        show={showModal}
        onHide={() => setShowModal(false)}
        dailyPredictionList={dailyPredictionList}
        predictionTitle={predictionTitle}
      />
    </>
  );
};

export default Prediction;
